@if (skjema().spoersmaal.length > 0) {
    <spoerreundersoekelse-besvarelse-skjema [skjemakontroll]="besvarelsesskjema()"/>
} @else {
    <div class="ingen-spoersmaal">{{ 'Skjemaet har ingen spørsmål' | translate }}</div>
}
